/**
 * Hinweis fuer Funktionen, die es in einer Kunden-Instanz nicht gibt (TQ #409):
 * cockpit-api bedient sie nicht (laufen zentral ueber die Cortex-DB). Ersetzt
 * 404-Fehler bzw. Mock-Daten.
 */
interface NotAvailableNoticeProps {
  /** Name der Funktion, z. B. "Audit-Log". */
  feature: string
}

export default function NotAvailableNotice({ feature }: NotAvailableNoticeProps) {
  return (
    <section className="aria-settings-card" role="status" aria-label={`${feature} nicht verfügbar`}>
      <h3>{feature}</h3>
      <p className="aria-settings-note">
        Diese Funktion ist in Ihrem Cockpit derzeit nicht verfügbar. Bei Fragen wenden Sie sich bitte an IT-SCE.
      </p>
    </section>
  )
}
